// JsFromRoutes CacheKey 79637fbf925881860c122cadb5ebdece
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const roommateGroupMembers = {
  resendEmail: definePathHelper("put", "/roommate_group_members/:roommate_group_member_id/resend_email"),
};
